module.exports = __webpack_public_path__ + "static/media/SomethingWentWrong.ab5b6e7d.png";